<template>
  <!-- 发货记录 -->
  <div class="logistics-recording">
    <ab-list-query :tabs="tabs" @handleTabs="handleTabs">
      <template #right>
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input
              placeholder="发货通知单"
              v-model.trim="formSearch.number"
              clearable
            >
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-select
              placeholder="单据状态"
              v-model="formSearch.status"
              clearable
              @change="searchForm"
            >
              <el-option
                v-for="option in options.status"
                :key="option.value"
                :label="option.desc"
                :value="option.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-select
              placeholder="货物状态"
              v-model="formSearch.goodsStatus"
              clearable
              @change="searchForm"
            >
              <el-option
                v-for="option in options.goodsStatus"
                :key="option.value"
                :label="option.desc"
                :value="option.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-select
              placeholder="发货方式"
              v-model="formSearch.sendType"
              clearable
              @change="searchForm"
            >
              <el-option
                v-for="option in options.sendType"
                :key="option.value"
                :label="option.desc"
                :value="option.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <ab-timeSearch
              class="searchBox"
              startSrc="创建日期起"
              endSrc="创建日期止"
              v-model="formSearch.createTimeArray"
              @searchEvent="createTimeChange"
            ></ab-timeSearch>
          </el-col>
          <el-col
            :span="4"
            class="text-left"
          >
            <el-button @click="searchForm">搜索</el-button>
            <el-button
              link
              class="btn-svg"
              @click="resetForm"
            >
              <ab-svg name="qingchu"></ab-svg>清除
            </el-button>
          </el-col>
        </el-row>
      </template>

      <template #toolbar>
        <el-button
          type="primary"
          :loading="loading.export"
          @click="exportFile"
        >导出</el-button>

        <el-button
          :loading="loading.print"
          :disabled="!multiSelected.length"
          @click="printFile"
        >打印发货单</el-button>

        <el-button
          :loading="loading.delete"
          :disabled="deleteDisabled"
          @click="deleteSelect"
        >删除</el-button>
      </template>

      <template #table>
        <ab-table
          class="materialTable"
          ref="table"
          stripe
          showEdit
          showSelection
          showMoreEdit
          selectionWidth="45"
          indexWidth="50"
          widths="180"
          isFilter="operator"
          :column-list="columns"
          :table-list="tableData"
          :dataListLoading="loading.table"
          :handleSelectionChange="selectionChange"
          :filterArry="['创建人', '确认人']"
          @filterColumns="filterColumns"
        >
          <template #statusDesc="scope">
            <span :class="getStatusClass(scope.row.status)"></span>
            {{ scope.row.statusDesc }}
          </template>

          <template #goodsStatusDesc="scope">
            <span :class="getGoodsStatusClass(scope.row.goodsStatus)"></span>
            {{ scope.row.goodsStatusDesc }}
          </template>

          <template #operator="scope">
            <el-button
              v-if="scope.row.haveFile"
              type="text"
              link
              @click="viewFile(scope.row)"
            >发货单</el-button>

            <el-popover
              v-else-if="scope.row.goodsStatus == '04'"
              placement="top-start"
              width="250"
              trigger="click">
              <div style="padding: 10px; font-size: 14px">
                <p>承运商：{{ deliveryInfo.carrierIdDesc }}</p>
                <p>运单号：{{ deliveryInfo.deliverTransportNo }}</p>
              </div>
              <template #reference>
                <el-button
                  type="text"
                  link
                  @click="viewDelivery(scope.row)"
                >查看快递</el-button>
              </template>
            </el-popover>

            <el-button
              v-else
              type="text"
              link
              @click="getDetail(scope.row)"
            >详情</el-button>
          </template>

          <template #moreOper="scope">
            <el-button
              v-if="scope.row.haveFile"
              type="text"
              link
              @click="viewFile(scope.row)"
            >查看发货单</el-button>

            <el-popover
              v-else-if="scope.row.goodsStatus == '04'"
              placement="top-start"
              width="250"
              trigger="click">
              <div style="padding: 10px; font-size: 14px">
                <p>承运商：{{ deliveryInfo.carrierIdDesc }}</p>
                <p>运单号：{{ deliveryInfo.deliverTransportNo }}</p>
              </div>
              <template #reference>
                <el-button
                  type="text"
                  link
                  @click="viewDelivery(scope.row)"
                >查看快递</el-button>
              </template>
            </el-popover>

            <el-button
              type="text"
              link
              @click="getDetail(scope.row)"
            >详情</el-button>
          </template>
        </ab-table>
      </template>

      <template #page>
        <ab-page
          :pageTotal="page.total"
          :currentPage="page.currentPage"
          :pageSize="page.pageSize"
          :pageSizes="page.pageSizes"
          @searchForm="pageSearch"
        ></ab-page>
      </template>
    </ab-list-query>

    <ab-upload-once :params="fileView" :isUpload="false" :isDelete="false" :showFoot="false"></ab-upload-once>
  </div>
</template>

<script>
export default {
  name: 'delivery-history',
  data() {
    return {
      tabs: [
        { name: '全部', value: '', state: '' },
        { name: '待提交', value: '', state: '1' },
        { name: '进行中', value: '', state: '2' },
        { name: '已完成', value: '', state: '3' }
      ],
      activedName: '',
      options: {},
      loading: {
        table: false,
        export: false,
        print: false,
        delete: false
      },
      formSearch: {},
      columns: [
        {
          props: 'number',
          labels: '发货通知单',
          widths: 150
        },
        {
          props: 'createTimeDesc',
          labels: '创建日期',
          widths: 100
        },
        {
          props: 'statusDesc',
          labels: '单据状态',
          widths: 90,
          slot: 'slot'
        },
        {
          props: 'goodsStatusDesc',
          labels: '货物状态',
          widths: 90,
          slot: 'slot'
        },
        {
          props: 'custOrderNo',
          labels: '订单编号',
          widths: 150
        },
        {
          props: 'sendTypeDesc',
          labels: '发货方式',
          widths: 80
        },
        {
          props: 'count',
          labels: '发货数量',
          widths: 80
        },
        {
          props: 'piece',
          labels: '件数',
          align: 'left',
          widths: 80
        },
        {
          props: 'receiveCompanyName',
          labels: '收货公司',
          widths: 140
        },
        {
          props: 'createByName',
          labels: '创建人',
          widths: 80
        },
        {
          props: 'auditByName',
          labels: '确认人',
          widths: 80
        }
      ],
      //列表数据
      tableData: [],
      // 勾选行
      multiSelected: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        total: 0
      },
      deliveryInfo: {},
      fileView: {
        sourceBillId: '',
        sourceBillNumber: '',
        sourceBillType: 'SendNotice',
        show: false,
        items: [
          {
            title: '发货单',
            attachType: '020'
          }
        ]
      }
    }
  },

  computed: {
    deleteDisabled () {
      return !this.multiSelected.length || this.multiSelected.filter(row => row.status !== 1 && row.status !== 4).length
    },
    bizTypeNow: {
        get() {
            return (
                this.$store.state.bizTypeNow 
            )
        }
    },
  },

  created() {
    this.getSelectList()
  },
  activated() {
    this.searchForm()
  },

  methods: {
    handleTabs(item) {
      this.activedName = item
      this.searchForm()
    },

    getSelectList() {
      this.$post('/tms/client/sendNotice/typeList').then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.options = data.result
        } else {
          this.options = {}
        }
      })
    },

    createTimeChange(value) {
      if (value) {
        this.formSearch.createTimeStart = value[0]
        this.formSearch.createTimeEnd = value[1]
      } else {
        this.formSearch.createTimeStart = ''
        this.formSearch.createTimeEnd = ''
      }
      this.searchForm()
    },

    filterColumns(array) {
      this.columns = array
    },

    searchForm() {
      this.page.currentPage = 1
      this.getDataList()
    },

    resetForm() {
      this.formSearch = {}
    },

    pageSearch(obj) {
      this.page.currentPage = obj.currentPage
      this.page.pageSize = obj.pageSize
      this.getDataList()
    },

    getDataList() {
      let params = Object.assign({}, this.formSearch)
      params.sendNoticeStatusChoice = this.activedName
      params.bizTypeList = ['01', '02', '11']
      if (this.bizTypeNow == '01') {
        params.bizTypeList = ['01', '02']
      } else if (this.bizTypeNow == '02') {
        params.bizTypeList = ['03', '04']
      }
      this.$post('/tms/client/sendNotice/list', {
        data: params,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      }, this.loading, 'table').then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.tableData = data.result.list
          this.page.total = data.result.total
          this.tabs.forEach(e => {
            if (e.name === '待提交') {
              e.value = data.extra && data.extra.waitSubmitCount || 0
            } else if (e.name === '进行中') {
              e.value = data.extra && data.extra.inProgressCount || 0
            }
          })
        }
      })
    },

    selectionChange(array) {
      this.multiSelected = array
    },

    // 单据状态class
    getStatusClass(value) {
      if (value == '1') { // 已保存
        return 'status-E21010'
      } else if (value == '2') { // 已确认
        return 'status-13227A'
      } else if (value == '3') { // 已处理
        return 'status-0AB2A8'
      } else if (value == '4') { // 已退回
        return 'status-B1B1B1'
      } else {
        return ''
      }
    },

    // 货物状态class
    getGoodsStatusClass(value) {
      if (value == '01') { // 派送中
        return 'status-FF8400'
      } else if (value == '02') { // 已签收
        return 'status-0AB2A8'
      } else if (value == '03') { // 已自提
        return 'status-13227A'
      } else if (value == '04') { // 已快递
        return 'status-1165D4'
      } else if (value == '05') { // 客户物流
        return 'status-B1B1B1'
      } else {
        return ''
      }
    },

    // 导出
    exportFile() {
      const excelField = this.columns.map(e => e.props)
      let params = Object.assign({}, this.formSearch, { excelField: excelField })
      params.sendNoticeStatusChoice = this.activedName
        if(this.bizTypeNow == '01') {
            params.bizTypeList = ['01', '02', '11']
        }else if(this.bizTypeNow == '02'){
            params.bizTypeList = ['03', '04', '06']
        }
      this.$post('/tms/client/sendNotice/export', { data: params }, this.loading, 'export').then(({ data }) => {
        if (data && data.code === 'C0000') {
          // 创建隐藏的可下载链接
          var eleLink = document.createElement('a')
          eleLink.download = ''
          eleLink.style.display = 'none'
          // 字符内容转变成blob地址
          eleLink.href = data.message
          // 触发点击
          document.body.appendChild(eleLink)
          eleLink.click()
          // 然后移除
          document.body.removeChild(eleLink)
        }
      })
    },

    // 打印发货单
    printFile() {
      this.$post('/tms/client/sendNotice/exportPrint', {
        ids: this.multiSelected.map(row => row.id)
      }, this.loading, 'print').then(({ data }) => {
        if (data && data.code === 'C0000') {
          data.result.forEach((url, index) => {
            setTimeout(() => {
              window.open(url)
            }, index * 1000)
          })
        } else {
          this.$message({
            type: 'error',
            message: data.message,
            offset: 380,
            grouping: true
          })
        }
      })
    },

    // 删除
    deleteSelect() {
      this.$post('/tms/client/sendNotice/del', {
        ids: this.multiSelected.map(row => row.id)
      }, this.loading, 'delete').then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.$message({
            type: 'success',
            message: data.message,
            offset: 380,
            grouping: true
          })
          this.searchForm()
        } else {
          this.$message({
            type: 'error',
            message: data.message,
            offset: 380,
            grouping: true
          })
        }
      })
    },

    // 查看发货单
    viewFile(row) {
      this.fileView.sourceBillId = row.id
      this.fileView.sourceBillNumber = row.number
      this.fileView.show = true
    },

    // 查看快递
    viewDelivery(row) {
      this.deliveryInfo = {}
      this.$get(`/tms/client/sendNotice/expressaged?fhNumber=${row.number}`).then(({ data }) => {
        if(data.code === 'C0000') {
          this.deliveryInfo = {
            deliverTransportNo: data.result.deliverTransportNo,
            carrierIdDesc: data.result.carrierIdDesc
          }
        }
      })
    },

    // 详情
    getDetail(row) {
      this.$router.push({
        path: '/logistics-detail',
        query: {
          action: [1, 4].includes(row.status) ? 'edit' : 'view',
          id: row.id,
          cache: false
        }
      })
    }
  }
}
</script>

<style lang="scss">
.logistics-recording {
  .el-table-fixed-column--right {
    .el-button + .el-button {
      position: relative;
      margin-left: 14px !important;
      &::before {
        content: '';
        position: absolute;
        left: -8px;
        top: 4px;
        width: 1px;
        height: 10px;
        background: #bfbfbf;
      }
    }
  }
}
</style>
